export default __webpack_public_path__ + "static/media/extensionIcon.705464be.svg";